import React from 'react'
import { List } from 'semantic-ui-react'

const RenderDocumentsList = ({folderData,folder,docTypes,renderItem}) => {
    const {documents} = folderData
    let parentDocs = Array.from(documents.keys())
    const folderName = docTypes.find((item) => {
      return item.name === folder
    })?.shortLabel

 return (
      <List.Item>
      <List.Icon name='folder' />
      <List.Content>
        <List.Header>{folder === "MISC" ? "MISC"  : folderName}</List.Header>
        <List.List >
         {parentDocs.map((parentDoc, index) => {
               let doc = documents.get(parentDoc)
               return (<List.Item key={`${parentDoc}-${index}-${doc[0]?.docid}`}>
                    <List.Content style={{padding:'0px'}} >
                   {   renderItem(`${folder}-${index+1}`,doc)}  
                </List.Content>
                  
                   </List.Item>)
               })}
        </List.List>
      </List.Content>
       </List.Item>
  )
}

export default React.memo(RenderDocumentsList)